module.exports = __webpack_public_path__ + "img/bg-img-0-dark.564690a3.png";